import { createAction, props } from '@ngrx/store';
import { Association, FeedbackType } from '@shared';

export const trackLoadJobCandidates = createAction(
  '[Activity Tracking][JobMatches] Load Job Candidates',
  props<{
    payload: { jobId: number; category: string; params: { offset?: number; sort?: string } };
  }>(),
);

export const trackLoadCandidates = createAction(
  '[Activity Tracking][Candidates] Load Candidates',
  props<{ payload: any }>(),
);

export const trackFeedbackCreate = createAction(
  '[Activity Tracking][Feedback] Create',
  props<{
    payload: {
      jobId: number;
      candidateId: number;
      feedbackType: FeedbackType;
      feedbackValue: any;
    };
  }>(),
);

export const trackAssociateCandidates = createAction(
  '[Activity Tracking][Candidates] Associate Candidates',
  props<{
    payload: {
      jobId: number;
      candidateIds: number[];
      associations: Partial<Association>[];
    };
  }>(),
);

export const trackViewCandidateDetails = createAction(
  '[Activity Tracking][Candidate] View candidate details',
  props<{
    payload: {
      candidateId: number;
      jobId?: number;
      talentPoolId?: number;
      viewContext: 'PROJECT' | 'NON_PROJECT';
    };
  }>(),
);
